/** Личные сообщения бота: тексты и выключатели. */

import type { ReactNode } from 'react';

import { NotificationEditor } from '../../components/notification-editor.tsx';
import { Section, type SettingsTabProps } from './shared.tsx';

export function DmTab({ draft, update }: SettingsTabProps): ReactNode {
  return (
    <Section
      title="Личные сообщения бота"
      description="Что бот пишет людям в личные сообщения. Ручная рассылка сюда не входит: её текст пишется каждый раз заново."
    >
      <NotificationEditor
        value={draft.notifications}
        onChange={(next) => {
          update('notifications', next);
        }}
      />
    </Section>
  );
}
